import {
    ColumnStructure,
    ColumnsStructure
} from '../types/ColumnStructureItem';
import { sortCitiesByName } from './sortCitiesByName';

export const buildColumnStructure = (list: ColumnStructure, columlCount: number): ColumnsStructure => {
    const sortedList = sortCitiesByName(list);
    let columnNum = 0;
    const preparedStructure: ColumnsStructure = [];

    for(const item of sortedList){
        const currentColumnData = preparedStructure[columnNum] ?? [];
        currentColumnData.push(item);

        preparedStructure[columnNum] = currentColumnData;

        if(columnNum === (columlCount - 1)){
            columnNum = 0;
        } else {
            columnNum++;
        }
    }

    return preparedStructure;
}

export const splitIntoSequentialColumns = <T>(list: T[], columnCount: number): T[][] => {
    if (columnCount <= 1) {
        return [list];
    }
    const n = list.length;
    if (n === 0) {
        return [];
    }
    const rows = Math.ceil(n / columnCount);
    const columns: T[][] = [];
    for (let c = 0; c < columnCount; c++) {
        const start = c * rows;
        if (start >= n) {
            break;
        }
        columns.push(list.slice(start, start + rows));
    }
    return columns;
};
